import ClientSetManagementPage from "../pages/management-campaigns/ClientSetManagementPage";

const CampaignManagementRoutes = {
    path: "campaigns/*",
    defaultRoute: "",
    children: [
        {
            path: 'client-sets/:clientSetId?',
            roles: [],
            element: ClientSetManagementPage
        },
        // {
        //     path: 'campaigns',
        //     roles: [],
        //     element: CampaignManagementLayout,
        //     children: [
        //         // TODO: Campaign Management tabs
        //     ]
        // }
    ]
};

export const CampaignManagementRouteTabs = () => <></>; // TODO

export default CampaignManagementRoutes;